import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const Tme: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/Tme.${label}.${locale}.json`)}>
      <TmeComponent />
    </I18nProvider>
  );
};

export const TmeComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { state } = useMeterReadingsFlow();
  const { trackFunnelCompleted } = useTracking();
  const isAuthenticated = state.context.isAuthenticated;
  const buttonText = isAuthenticated ? t('tme.buttonLinkAuthenticated.text') : t('tme.buttonLink.text');
  const buttonLink = isAuthenticated ? t('tme.buttonLinkAuthenticated.href') : t('tme.buttonLink.href');

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.TariffMigration'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('tme.title')}
      content={t('tme.content')}
      buttonHref={buttonLink}
      buttonText={buttonText}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('tme.imageSrc')}`,
        },
      }}
    />
  );
};
